<template>
    <div class="box-list">
        <div
            v-for="(item, i) in list"
            :key="'boxlisnt' + i"
            class="list-item"
            :style="{'width': itemWidth}">
            <div>
                <div
                    class="list-icon"
                    :class="`myicon-${item.icon}`"></div>
                <div class="list-title">
                    {{ item.title }}
                </div>
                <div
                    class="list-data"
                    :style="{'color': item.color}">
                    {{ item.value }} <span>{{ item.unit }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        list: {
            type: Array,
            default: () => { return [] }
        },
        line: {
            type: Number,
            default: 3
        }
    },
    computed: {
        itemWidth() {
            return `${100 / this.line}%`
        }
    },
    data() {
        return {}
    }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/icon.scss";
.box-list {
    display: flex;
    flex-wrap: wrap;
    font-size: 14px;
    .list-item {
        // flex: 1;
        display: flex;
        justify-content: flex-start;
        padding: 15px 0;
        padding-left: 3%;
        .list-title {
            font-size: 20px;
        }
        > div {
            padding: 20px 0 20px 80px;
            position: relative;
            display: flex;
            flex-direction: column;
            justify-content: center;
            margin-top: 10px;
        }
        .list-icon {
            width: 65px;
            height: 70px;
            position: absolute;
            top: 50%;
            left: 10px;
            transform: translate(0, -50%);
            background-size: 100%;
            background-position: center center;
        }
        .list-data {
            font-size: 30px;
            margin-top: 10px;
            white-space: nowrap;
            > span {
                font-size: 14px;
            }
        }
    }
}
</style>